import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject } from 'rxjs';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { ManagementApiService } from 'src/app/services';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { OrganizationDataService } from 'src/app/services/organization-data.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { CustomAvatarService } from 'src/app/services/custom-avatar.service';
@Component({
    selector: 'app-organization-card',
    templateUrl: './organization-card.component.html',
    styleUrls: ['./organization-card.component.scss'],
    standalone: false,
})
export class OrganizationCardComponent implements OnInit, AfterViewInit, OnDestroy {
    searchText: string;
    isOrganization: boolean = false;
    organization = [];
    organizationNames: any[] = [];
    organizationCopy;
    isUserLoggedIn: boolean = false;
    organizationSearch;
    ngUnsubscribe: Subject<any>;
    hideEditOption: boolean;
    hideAddOption: boolean = false;

    constructor(
        private managementApiService: ManagementApiService,
        private globalEmittersService: GlobalEmittersService,
        private cd: ChangeDetectorRef,
        private ngxUiLoaderService: NgxUiLoaderService,
        private router: Router,
        private organizationDataService: OrganizationDataService,
        private user_utility: UserUtilityService,
        private customAvatarService: CustomAvatarService
    ) {
        this.ngUnsubscribe = new Subject();
    }

    async ngOnInit(): Promise<void> {
        this.hideAddOption = await this.user_utility.checkUserPermissionDataAndRoute('add-organization', userActions.Create);
        this.hideEditOption = await this.user_utility.checkUserPermissionDataAndRoute('add-organization', userActions.Edit);

        if (this.organizationDataService.allOrganizations && !this.organizationDataService.isOrganzationEdit) {
            this.organization = this.organizationDataService.allOrganizations;
            this.organizationSearch = this.organizationDataService.allOrganizations;
            this.isOrganization = true;
            this.organizationNames = this.organizationDataService.organizationNames;
            this.getOrganizations();
        } else {
            this.getOrganizations();
            this.organizationDataService.isOrganzationEdit = false;
        }
        if (localStorage.getItem('selectedOrgId')) {
            this.organizationDataService.currentOrgId = localStorage.getItem('selectedOrgId');
            this.organizationDataService.currentOrg = localStorage.getItem('selectedOrganizationName');
            this.highlightOrg();
            this.globalEmittersService.currentOrg.next(this.organizationDataService.currentOrg);
            this.globalEmittersService.currentOrgId.next(this.organizationDataService.currentOrgId);
        }
        this.handleAllSubscriptions();
    }

    ngAfterViewInit(): void {
        //    this.highlightOrg();
        if (!localStorage.getItem('selectedOrgId')) {
            this.organizationDataService.currentOrgId = '';
            var parentDiv = document.querySelector('.organization_container');
            for (let x = 0; x < parentDiv?.children.length; x++) {
                let child = parentDiv.children[x];

                child.children[0]?.children[0]?.classList.remove('organization_active');
            }
        }
        this.cd.detectChanges();
    }

    handleAllSubscriptions(): void {
        this.globalEmittersService.currentOrgId.subscribe((orgId: string) => {
            if (orgId) {
                // this.currentOrg = orgName;
                this.highlightOrg();
            } else {
                this.DeselectOrg();
            }
        });
    }

    getOrganizations() {
        this.ngxUiLoaderService.start();
        this.managementApiService.getOrganizations().subscribe(
            (result) => {
                this.ngxUiLoaderService.stop();
                this.isOrganization = true;
                if (result.success === true) {
                    this.organization = result.response;
                    this.organizationCopy = result.response;
                    this.organizationSearch = result.response;
                    this.organizationDataService.allOrganizations = result.response;
                    this.organizationNames = [];
                    for (let x = 0; x < result.response.length; x++) {
                        this.organizationNames.push(result.response[x].organisationName);
                    }
                    // this.filterOrganizationNames(this.organizationNames);
                    setTimeout(() => {
                        this.highlightOrg();
                    }, 10);
                    this.cd.detectChanges();
                } else {
                    this.user_utility.errorModelPopup(result.message);
                }
            },
            (error) => {
                this.ngxUiLoaderService.stop();
                // this.toastrService.error("Something is wrong");
            }
        );
    }

    navigateAddOrg(orgId: string) {
        this.router.navigate(['/management/edit-organization', orgId]);
    }

    searchResult(event: any) {
        let searchText = event.target.value;
        this.organization = this.organizationSearch.filter((item) => {
            return item.organisationName.toLocaleLowerCase().replace(/\s+/g, '').trim().includes(searchText.replace(/\s+/g, '').trim().toLowerCase());
        });
        this.highlightOrg();
    }

    selectOrg(org: any) {
        this.router.navigate(['/management/instance'], {
            queryParams: { organizationId: org.organisationId },
        });
        let parentDiv = document.querySelector('.organization_container');
        for (let x = 0; x < parentDiv.children.length; x++) {
            parentDiv.children[x].children[0].children[0].classList.remove('organization_active');
        }
        let selectedElement = document.getElementById(`${org.organisationId}`);
        this.globalEmittersService.currentOrg.next(org.organisationName);
        this.globalEmittersService.currentOrgId.next(org.organisationId);
        this.organizationDataService.currentOrgId = org.organisationId;
        this.organizationDataService.currentOrg = org.organisationName;
        localStorage.setItem('selectedOrganizationName', org.organisationName);
        localStorage.setItem('selectedOrganization', JSON.stringify(org));
        localStorage.setItem('selectedOrgId', org.organisationId);
        // removing the current instance stored in local storage because each organization has different instances
        // on selection on new organization previously selected have to removed
        if (localStorage.getItem('currentInstanceName')) {
            localStorage.removeItem('currentInstanceName');
            localStorage.removeItem('currentInstanceId');
            this.globalEmittersService.currentInstanceName.next(null);
        }
        let child = selectedElement.children[0];
        child.children[0].classList.add('organization_active');
    }

    highlightOrg() {
        if (this.organizationDataService.currentOrgId) {
            let element = document.getElementById(this.organizationDataService.currentOrgId);
            if (element) {
                let child = element.children[0];
                child.children[0].classList.add('organization_active');
            }
        }
    }

    DeselectOrg() {
        var parentDiv = document.querySelector('.organization_container');
        for (let x = 0; x < parentDiv?.children.length; x++) {
            let child = parentDiv.children[x];
            child?.children[0]?.children[0]?.classList.remove('organization_active');
        }
        this.cd.detectChanges();
    }

    getInitials(name: string): string {
        if (!name) return '';
        return this.customAvatarService.getShortInitials(name);
    }

    disableOrg(org: any) {
        return !this.user_utility.userData?.isSysAdmin && !org?.enabled;
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next(null);
        this.ngUnsubscribe.complete();
    }
}
